// extracted by mini-css-extract-plugin
export default {"newPassInputs":"t59A2","passwordFormControl":"N9iA7","passwordInput":"hQWSY"};